module.exports = __webpack_public_path__ + "img/bear_avatar.c1c2c798.png";